






















import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ContactProfile } from '../models/contactProfile';
import { Conversation } from '../models/conversation';
import { conversationApi } from '../services/conversationApi';
import ContactConversationList from './ContactConversationList.vue';

@Component({
	components: {
		ContactConversationList
	}
})
export default class ContactConversationModal extends Vue {
	@Getter public currentWorkspace: WorkspaceViewModel;

	public contactId: string;

	public loadingContactProfile: boolean = false;

	public conversations: Conversation[] = [];

	public contactProfile: ContactProfile | null = null;

	public async mounted() {
		this.contactId = this.$route.params.id;
		await this.loadContactProfile();
	}

	public async loadContactProfile(): Promise<void> {
		this.loadingContactProfile = true;
		const response = await conversationApi.getContactProfile(this.currentWorkspace.id, this.contactId);
		this.conversations = response.conversations;
		this.contactProfile = response.contact;
		this.loadingContactProfile = false;
	}

	public closeModal() {
		this.$router.push({ name: 'contacts-list' });
	}

	public get contactName(): string | undefined {
		if (this.contactProfile) {
			return !this.contactProfile.name ? 'Unknown' : this.contactProfile.name;
		}
		return 'Unknown';
	}
}
